import React, { memo, useState, useEffect, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { createSelector } from 'reselect';
import classNames from 'classnames';
import { Modal } from 'antd';
import styles from './CompetitiveProduct.module.less';
import { getLocalSoft, installSoft } from '../../actions/native';
import { logging } from '../../actions/log';
import { PCStoreJsBridge } from '../../nativeapi';
import { getAppDetails } from '../../actions/special';
import { logNative } from '../../utils/utils';

const selectLogInfo = createSelector(
  state => state.log,
  log => log.logInfo,
);

// productRecommendInfo 竞品引流数据
const selectProductRecommendInfo = createSelector(
  state => state.native,
  search => search.productRecommendInfo,
);

const selectInstalledSoft = createSelector(
  state => state.native,
  native => native.installedSoft,
);

const selectIsEnabledSilent = createSelector(
  state => state.layout,
  layout => layout.isEnabledSilent,
);
const selectSilentInstSoft = createSelector(
  state => state.native,
  native => native.supportSilentInstSoft,
);

const selectCompectiveProductDetails = createSelector(
  state => state.special,
  special => {
    return special.appDetails;
  },
);

const selectUpgradeSofts = createSelector(
  state => state.native,
  native => native.upgradeSofts,
);

export default memo(({ handleCancel, visible, softInfo, logInfo, buttonText }) => {
  const [info, setInfo] = useState(null); // 被安装竞品的信息
  const productRecommendInfo = useSelector(selectProductRecommendInfo); // 竞品引流
  const [init, setInit] = useState(false);

  const dispatch = useDispatch();
  const upgradeSofts = useSelector(selectUpgradeSofts); // 可更新
  const installedSoft = useSelector(selectInstalledSoft);
  const logInfoData = useSelector(selectLogInfo);
  const competitiveProductDetails = useSelector(selectCompectiveProductDetails);
  const silentInstSoft = useSelector(selectSilentInstSoft); // 支持快速静默安装的应用列表
  const isEnabledSilent = useSelector(selectIsEnabledSilent); // 是否打开快速静默安装
  // const [silentSoft, setSilentSoft] = useState(undefined);

  const [upgrade, setUpgrade] = useState(undefined);

  useEffect(() => {
    dispatch(getLocalSoft());
  }, []);

  // 查询当前是否已经安装
  useEffect(() => {
    if (upgradeSofts) {
      setUpgrade(
        upgradeSofts.find(
          soft_ => soft_.softID === softInfo.softID || soft_.SoftID === softInfo.softID,
        ),
      );
    }
  }, [softInfo, upgradeSofts]);

  // useEffect(() => {
  //   if (silentInstSoft && isEnabledSilent && info) {
  //     setSilentSoft(silentInstSoft.find(soft_ => soft_.softID === info.softID));
  //   }
  // }, [info, silentInstSoft, isEnabledSilent]);

  // 打桩---打开弹窗触发
  useEffect(() => {
    if (visible && info && competitiveProductDetails) {
      dispatch(
        logging({
          category: 'P',
          // 2 已安装 3 未安装
          action: info.type === '3' ? 'Download_Competitor' : 'Use_Competitor',
          label: '',
          param2: {
            competitor: info.lenovoProductId,
            softid: info.competeProductId,
            source: logInfoData.source,
            source_p: logInfoData.source_p,
            source_pp: logInfoData.source_pp,
          },
        }),
      );
    }
  }, [visible, info]);

  const calParams = (soft_info, button_Text, logInfo_para) => {
    const logParam2 = {
      source: logInfo_para.source,
      source_p: logInfoData.source_p,
      source_pp: logInfoData.source_pp,
      softid: soft_info.softID,
      softName: soft_info.softName,
      softType: '0', // 安卓(1)还是PC(0)应用
      type: upgrade ? 'u' : 'd', // 更新还是下载
      url: soft_info.downLoadUrl,
    };
    // 当为搜索结果也跳转过来的，带上附加信息
    if (logInfo_para.isSearch) {
      logParam2.search_type = logInfoData.search_type;
      logParam2.search_word = logInfoData.search_word;
    }
    // 联想词softcard  做特殊处理 参数通过 logInfo (即logInfo_para) 传入
    if (
      logInfo_para.isSearch &&
      (logInfo_para.search_type === 4 || logInfo_para.search_type === 5)
    ) {
      logParam2.source_p = logInfo_para.source_p;
      logParam2.source_pp = logInfo_para.source_pp;
      logParam2.search_type = logInfo_para.search_type;
      logParam2.search_word = logInfo_para.search_word;
    }

    let installparams = null;
    let silentSoft = null;
    if (silentInstSoft && isEnabledSilent) {
      silentSoft = silentInstSoft.find(soft_ => soft_.softID === soft_info.softID);
    }
    if (isEnabledSilent && silentSoft) {
      installparams = {};
      logParam2.type = upgrade ? 'xu' : 'xd';
      if (silentSoft.silentParamDic) {
        installparams.quiet = silentSoft.silentParamDic;
      }
      if (silentSoft.silentDirParamDic) {
        installparams.todir = silentSoft.silentDirParamDic;
      }
    }

    let softInfos = {};

    if (
      button_Text === buttonText ||
      button_Text === '安装' ||
      button_Text === '升级' ||
      button_Text === '快装'
    ) {
      softInfos = { ...soft_info, logInfo: logParam2, installparams, isClick: 'click' };
      // dispatch(installSoft(softInfos));
    } else if (button_Text === '打开') {
      // 按钮点击打桩
      logParam2.type = 'o';
    }

    return {
      logParam2,
      softInfos,
    };
  };

  const handleDownSoft = useCallback((soft_info = {}, logInfo_para = {}, downType) => {
    if (!soft_info.softID) {
      return;
    }
    // 根据类型判断继续下载还是下载竞品
    let logparams = null;
    switch (downType) {
      case 'keep':
        // 继续下载打桩
        logparams = {
          category: 'C',
          action: 'Use_Competitor_Install',
          param2: {
            source: logInfoData.source,
            source_p: logInfoData.source_p,
            source_pp: logInfoData.source_pp,
          },
        };
        break;
      case 'installnow':
        logparams = {
          category: 'C',
          action: 'Download_Competitor_Yes',
          label: '',
          param2: {
            competitor: info.lenovoProductId,
            softid: info.competeProductId,
            source: logInfoData.source,
            source_p: logInfoData.source_p,
            source_pp: logInfoData.source_pp,
          },
        };
        break;
      case 'installno':
        logparams = {
          category: 'C',
          action: 'Download_Competitor_No',
          label: '',
          param2: {
            competitor: info.lenovoProductId,
            softid: info.competeProductId,
            source: logInfoData.source,
            source_p: logInfoData.source_p,
            source_pp: logInfoData.source_pp,
          },
        };
        break;
      default:
        break;
    }
    dispatch(logging(logparams));

    const params = calParams(soft_info, buttonText, logInfo_para);
    const softInfos = {
      ...soft_info,
      logInfo: params.logParam2,
      installparams:
        downType !== 'installnow'
          ? softInfo && softInfo.installparams
          : params.softInfos && params.softInfos.installparams,
      isClick: 'click',
    };
    dispatch(installSoft(softInfos)); // 下载软件
    handleCancel(true); // 关闭弹窗
  });

  const handleOpenSoft = useCallback(() => {
    // 使用竞品打桩
    dispatch(
      logging({
        category: 'C',
        action: 'Use_Competitor',
        label: '',
        param2: {
          competitor: info.lenovoProductId,
          softid: info.competeProductId,
          source: logInfoData.source,
          source_p: logInfoData.source_p,
          source_pp: logInfoData.source_pp,
        },
      }),
    );
    PCStoreJsBridge.openSoft(info.appDetails);
    handleCancel(true); // 关闭弹窗
  });

  useEffect(() => {
    if (
      !productRecommendInfo ||
      !softInfo ||
      Object.keys(softInfo).length < 3 ||
      !installedSoft ||
      info ||
      init
    ) {
      return;
    }
    setInfo(null);

    // 排除即将要下载的软件原本已经下载过了--既  按钮打开或者升级不展示弹窗
    if (installedSoft.find(item => item.SoftID === softInfo.SoftID)) {
      setInit(true);
      handleCancel();
      return;
    }
    let type = '3'; // 安装类型 2.已安装 3.未安装
    const target = productRecommendInfo.filter(item => item.competeProductId === softInfo.SoftID);
    let intallTarget = null;
    if (target && target.length > 0) {
      intallTarget = installedSoft.find(item => item.SoftID === target[0].lenovoProductId);
      if (intallTarget) {
        type = '2';
      }
    }

    if (target && target[0]) {
      try {
        switch (type) {
          case '2':
            setInfo(() => {
              const obj = {
                ...target.find(item => item.type === '2'),
                appDetails: intallTarget,
              };

              dispatch(
                getAppDetails({
                  softid: obj.lenovoProductId || '',
                  bizInfo: softInfo.bizInfo || {},
                }),
              );
              return obj;
            });
            break;
          default:
            setInfo(() => {
              const obj = target.find(item => item.type !== '2');
              dispatch(
                getAppDetails({
                  softid: obj.lenovoProductId || '',
                  bizInfo: softInfo.bizInfo || {},
                }),
              );
              return obj;
            });
            break;
        }
      } catch (err) {
        logNative('js error', err);
      }
    } else {
      handleDownSoft(softInfo, logInfo);
      handleCancel(false);
    }
  }, [productRecommendInfo, softInfo, installedSoft]);
  const handleCancelDialog = useCallback(() => {
    dispatch(
      logging({
        category: 'C',
        action: info.type === '3' ? 'Download_Competitor_Close' : 'Use_Competitor_Close',
        label: '',
        param2: {
          competitor: info.lenovoProductId,
          softid: info.competeProductId,
          source: logInfoData.source,
          source_p: logInfoData.source_p,
          source_pp: logInfoData.source_pp,
        },
      }),
    );
    handleCancel(false);
  }, [dispatch, logInfoData, info]);

  if (!visible || !info) {
    return <></>;
  }
  if (info && info.type === '2' && !competitiveProductDetails) {
    return <></>;
  }

  return (
    <>
      <Modal
        visible={visible && Boolean(info)}
        style={{
          position: 'fixed',
          top: '250px',
          left: 'calc(50% - 180px)',
          zIndex: 1000,
          width: '360px',
          height: '180px',
          padding: '12px 15px',
          background: '#fff',
          boxShadow: '0px 3px 10px 0px rgba(0, 0, 0, 0.3)',
          borderRadius: '4px',
          boxSizing: 'border-box',
        }}
        bodyStyle={{
          padding: 0,
        }}
        wrapClassName={styles.modalWrapContainer}
        mask
        maskClosable={false}
        width={360}
        centered
        destroyOnClose
        footer={null}
        closable={false}
      >
        <div className={styles.modal_header}>
          <span className={styles.title}>温馨提示</span>
          <i
            className={classNames('iconfont icon-close', styles.icon_close)}
            onClick={() => {
              handleCancelDialog();
            }}
          />
        </div>
        <div className={styles.modal_content}>{info && info.title}</div>
        {info && info.type === '2' && (
          <div className={classNames(styles.modal_button, styles.modal_button_oper)}>
            <div
              className={classNames(styles.button, styles.install)}
              onClick={() => {
                handleDownSoft(softInfo, logInfo, 'keep');
              }}
            >
              继续下载
            </div>
            <div className={classNames(styles.button, styles.uninstall)} onClick={handleOpenSoft}>
              {info && info.buttonTitle && `${info.buttonTitle}`}
            </div>
          </div>
        )}
        {info && info.type === '3' && (
          <div className={classNames(styles.modal_button)}>
            <div
              className={classNames(styles.button, styles.install)}
              onClick={() => {
                handleDownSoft(softInfo, logInfo, 'installno');
              }}
            >
              我不想要
            </div>
            <div
              className={classNames(styles.button, styles.uninstall)}
              onClick={() => {
                handleDownSoft(
                  { ...competitiveProductDetails, bizInfo: softInfo.bizInfo },
                  logInfo,
                  'installnow',
                );
              }}
            >
              {(info && info.buttonTitle && `${info.buttonTitle}`) || '立即安装'}
            </div>
          </div>
        )}
      </Modal>
    </>
  );
});
